import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "task",
    serviceName: "auth",
    query: gql`
      query task($ids: [String]) {
        task(ids: $ids) {
          data {
            status
            doctor {
              id
              lat
              lng
              address
              site_url
              is_active
              tellphone
              postal_code
              check_messages
              register_date
              registered_number
              national_identifier
              status {
                id
                title
              }
              city {
                title
                state {
                  title
                }
              }
              media {
                id
                full_url
                collection_name
              }
            }
          }
        }
      }
    `,
  },
  done: {
    name: "doneRequest",
    serviceName: "auth",
    query: gql`
      mutation doneRequest($id: String!) {
        doneRequest(id: $id) {
          messages
        }
      }
    `,
  },
  reject: {
    name: "rejectRequest",
    serviceName: "auth",
    query: gql`
      mutation rejectRequest($id: String!) {
        rejectRequest(id: $id) {
          messages
        }
      }
    `,
  },
};

export default schema;
